/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeInventoryBotIdDto,
  ApiEnvelopeInventoryEmptyDto,
  ApiEnvelopeInventoryUnloadAreaConfigCreatedDto,
  ApiEnvelopeInventoryUnloadAreaConfigsResponse,
  ApiEnvelopeInventoryUnloadAtConfigCreatedDto,
  ApiEnvelopeInventoryUnloadAtConfigsResponse,
  InventoryRunUnloadAreaRequest,
  InventoryRunUnloadAtRequest,
  InventoryUnloadAreaConfigRequest,
  InventoryUnloadAtConfigRequest,
  InventoryUnloadConfigsStopUnloadAreaConfigParams
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type inventoryUnloadConfigsGetUnloadAtConfigsResponse200 = {
  data: ApiEnvelopeInventoryUnloadAtConfigsResponse
  status: 200
}

export type inventoryUnloadConfigsGetUnloadAtConfigsResponseSuccess = (inventoryUnloadConfigsGetUnloadAtConfigsResponse200) & {
  headers: Headers;
};
;

export type inventoryUnloadConfigsGetUnloadAtConfigsResponse = (inventoryUnloadConfigsGetUnloadAtConfigsResponseSuccess)

export const getInventoryUnloadConfigsGetUnloadAtConfigsUrl = () => {




  return `/api/inventory/unload-at-configs`
}

export const useInventoryUnloadConfigsGetUnloadAtConfigsHook = (): ( options?: RequestInit) => Promise<inventoryUnloadConfigsGetUnloadAtConfigsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getInventoryUnloadConfigsGetUnloadAtConfigsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventoryUnloadConfigsCreateUnloadAtConfigResponse200 = {
  data: ApiEnvelopeInventoryUnloadAtConfigCreatedDto
  status: 200
}

export type inventoryUnloadConfigsCreateUnloadAtConfigResponseSuccess = (inventoryUnloadConfigsCreateUnloadAtConfigResponse200) & {
  headers: Headers;
};
;

export type inventoryUnloadConfigsCreateUnloadAtConfigResponse = (inventoryUnloadConfigsCreateUnloadAtConfigResponseSuccess)

export const getInventoryUnloadConfigsCreateUnloadAtConfigUrl = () => {




  return `/api/inventory/unload-at-configs`
}

export const useInventoryUnloadConfigsCreateUnloadAtConfigHook = (): (inventoryUnloadAtConfigRequest?: InventoryUnloadAtConfigRequest, options?: RequestInit) => Promise<inventoryUnloadConfigsCreateUnloadAtConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (inventoryUnloadAtConfigRequest?: InventoryUnloadAtConfigRequest, options?: RequestInit) => {

        return customFetcher(getInventoryUnloadConfigsCreateUnloadAtConfigUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryUnloadAtConfigRequest)
  }
);
      }
  }


export type inventoryUnloadConfigsUpdateUnloadAtConfigResponse200 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 200
}

export type inventoryUnloadConfigsUpdateUnloadAtConfigResponse404 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 404
}

export type inventoryUnloadConfigsUpdateUnloadAtConfigResponseSuccess = (inventoryUnloadConfigsUpdateUnloadAtConfigResponse200) & {
  headers: Headers;
};
export type inventoryUnloadConfigsUpdateUnloadAtConfigResponseError = (inventoryUnloadConfigsUpdateUnloadAtConfigResponse404) & {
  headers: Headers;
};

export type inventoryUnloadConfigsUpdateUnloadAtConfigResponse = (inventoryUnloadConfigsUpdateUnloadAtConfigResponseSuccess | inventoryUnloadConfigsUpdateUnloadAtConfigResponseError)

export const getInventoryUnloadConfigsUpdateUnloadAtConfigUrl = (id: string,) => {




  return `/api/inventory/unload-at-configs/${id}`
}

export const useInventoryUnloadConfigsUpdateUnloadAtConfigHook = (): (id: string,
    inventoryUnloadAtConfigRequest?: InventoryUnloadAtConfigRequest, options?: RequestInit) => Promise<inventoryUnloadConfigsUpdateUnloadAtConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    inventoryUnloadAtConfigRequest?: InventoryUnloadAtConfigRequest, options?: RequestInit) => {

        return customFetcher(getInventoryUnloadConfigsUpdateUnloadAtConfigUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryUnloadAtConfigRequest)
  }
);
      }
  }


export type inventoryUnloadConfigsDeleteUnloadAtConfigResponse200 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 200
}

export type inventoryUnloadConfigsDeleteUnloadAtConfigResponse404 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 404
}

export type inventoryUnloadConfigsDeleteUnloadAtConfigResponseSuccess = (inventoryUnloadConfigsDeleteUnloadAtConfigResponse200) & {
  headers: Headers;
};
export type inventoryUnloadConfigsDeleteUnloadAtConfigResponseError = (inventoryUnloadConfigsDeleteUnloadAtConfigResponse404) & {
  headers: Headers;
};

export type inventoryUnloadConfigsDeleteUnloadAtConfigResponse = (inventoryUnloadConfigsDeleteUnloadAtConfigResponseSuccess | inventoryUnloadConfigsDeleteUnloadAtConfigResponseError)

export const getInventoryUnloadConfigsDeleteUnloadAtConfigUrl = (id: string,) => {




  return `/api/inventory/unload-at-configs/${id}`
}

export const useInventoryUnloadConfigsDeleteUnloadAtConfigHook = (): (id: string, options?: RequestInit) => Promise<inventoryUnloadConfigsDeleteUnloadAtConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getInventoryUnloadConfigsDeleteUnloadAtConfigUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type inventoryUnloadConfigsRunUnloadAtConfigResponse200 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 200
}

export type inventoryUnloadConfigsRunUnloadAtConfigResponse400 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 400
}

export type inventoryUnloadConfigsRunUnloadAtConfigResponse404 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 404
}

export type inventoryUnloadConfigsRunUnloadAtConfigResponseSuccess = (inventoryUnloadConfigsRunUnloadAtConfigResponse200) & {
  headers: Headers;
};
export type inventoryUnloadConfigsRunUnloadAtConfigResponseError = (inventoryUnloadConfigsRunUnloadAtConfigResponse400 | inventoryUnloadConfigsRunUnloadAtConfigResponse404) & {
  headers: Headers;
};

export type inventoryUnloadConfigsRunUnloadAtConfigResponse = (inventoryUnloadConfigsRunUnloadAtConfigResponseSuccess | inventoryUnloadConfigsRunUnloadAtConfigResponseError)

export const getInventoryUnloadConfigsRunUnloadAtConfigUrl = (id: string,) => {




  return `/api/inventory/unload-at-configs/${id}/run`
}

export const useInventoryUnloadConfigsRunUnloadAtConfigHook = (): (id: string,
    inventoryRunUnloadAtRequest?: InventoryRunUnloadAtRequest, options?: RequestInit) => Promise<inventoryUnloadConfigsRunUnloadAtConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    inventoryRunUnloadAtRequest?: InventoryRunUnloadAtRequest, options?: RequestInit) => {

        return customFetcher(getInventoryUnloadConfigsRunUnloadAtConfigUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryRunUnloadAtRequest)
  }
);
      }
  }


export type inventoryUnloadConfigsGetUnloadAreaConfigsResponse200 = {
  data: ApiEnvelopeInventoryUnloadAreaConfigsResponse
  status: 200
}

export type inventoryUnloadConfigsGetUnloadAreaConfigsResponseSuccess = (inventoryUnloadConfigsGetUnloadAreaConfigsResponse200) & {
  headers: Headers;
};
;

export type inventoryUnloadConfigsGetUnloadAreaConfigsResponse = (inventoryUnloadConfigsGetUnloadAreaConfigsResponseSuccess)

export const getInventoryUnloadConfigsGetUnloadAreaConfigsUrl = () => {




  return `/api/inventory/unload-area-configs`
}

export const useInventoryUnloadConfigsGetUnloadAreaConfigsHook = (): ( options?: RequestInit) => Promise<inventoryUnloadConfigsGetUnloadAreaConfigsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getInventoryUnloadConfigsGetUnloadAreaConfigsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type inventoryUnloadConfigsCreateUnloadAreaConfigResponse200 = {
  data: ApiEnvelopeInventoryUnloadAreaConfigCreatedDto
  status: 200
}

export type inventoryUnloadConfigsCreateUnloadAreaConfigResponseSuccess = (inventoryUnloadConfigsCreateUnloadAreaConfigResponse200) & {
  headers: Headers;
};
;

export type inventoryUnloadConfigsCreateUnloadAreaConfigResponse = (inventoryUnloadConfigsCreateUnloadAreaConfigResponseSuccess)

export const getInventoryUnloadConfigsCreateUnloadAreaConfigUrl = () => {




  return `/api/inventory/unload-area-configs`
}

export const useInventoryUnloadConfigsCreateUnloadAreaConfigHook = (): (inventoryUnloadAreaConfigRequest?: InventoryUnloadAreaConfigRequest, options?: RequestInit) => Promise<inventoryUnloadConfigsCreateUnloadAreaConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (inventoryUnloadAreaConfigRequest?: InventoryUnloadAreaConfigRequest, options?: RequestInit) => {

        return customFetcher(getInventoryUnloadConfigsCreateUnloadAreaConfigUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryUnloadAreaConfigRequest)
  }
);
      }
  }


export type inventoryUnloadConfigsUpdateUnloadAreaConfigResponse200 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 200
}

export type inventoryUnloadConfigsUpdateUnloadAreaConfigResponse404 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 404
}

export type inventoryUnloadConfigsUpdateUnloadAreaConfigResponseSuccess = (inventoryUnloadConfigsUpdateUnloadAreaConfigResponse200) & {
  headers: Headers;
};
export type inventoryUnloadConfigsUpdateUnloadAreaConfigResponseError = (inventoryUnloadConfigsUpdateUnloadAreaConfigResponse404) & {
  headers: Headers;
};

export type inventoryUnloadConfigsUpdateUnloadAreaConfigResponse = (inventoryUnloadConfigsUpdateUnloadAreaConfigResponseSuccess | inventoryUnloadConfigsUpdateUnloadAreaConfigResponseError)

export const getInventoryUnloadConfigsUpdateUnloadAreaConfigUrl = (id: string,) => {




  return `/api/inventory/unload-area-configs/${id}`
}

export const useInventoryUnloadConfigsUpdateUnloadAreaConfigHook = (): (id: string,
    inventoryUnloadAreaConfigRequest?: InventoryUnloadAreaConfigRequest, options?: RequestInit) => Promise<inventoryUnloadConfigsUpdateUnloadAreaConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    inventoryUnloadAreaConfigRequest?: InventoryUnloadAreaConfigRequest, options?: RequestInit) => {

        return customFetcher(getInventoryUnloadConfigsUpdateUnloadAreaConfigUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryUnloadAreaConfigRequest)
  }
);
      }
  }


export type inventoryUnloadConfigsDeleteUnloadAreaConfigResponse200 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 200
}

export type inventoryUnloadConfigsDeleteUnloadAreaConfigResponse404 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 404
}

export type inventoryUnloadConfigsDeleteUnloadAreaConfigResponseSuccess = (inventoryUnloadConfigsDeleteUnloadAreaConfigResponse200) & {
  headers: Headers;
};
export type inventoryUnloadConfigsDeleteUnloadAreaConfigResponseError = (inventoryUnloadConfigsDeleteUnloadAreaConfigResponse404) & {
  headers: Headers;
};

export type inventoryUnloadConfigsDeleteUnloadAreaConfigResponse = (inventoryUnloadConfigsDeleteUnloadAreaConfigResponseSuccess | inventoryUnloadConfigsDeleteUnloadAreaConfigResponseError)

export const getInventoryUnloadConfigsDeleteUnloadAreaConfigUrl = (id: string,) => {




  return `/api/inventory/unload-area-configs/${id}`
}

export const useInventoryUnloadConfigsDeleteUnloadAreaConfigHook = (): (id: string, options?: RequestInit) => Promise<inventoryUnloadConfigsDeleteUnloadAreaConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getInventoryUnloadConfigsDeleteUnloadAreaConfigUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type inventoryUnloadConfigsRunUnloadAreaConfigResponse200 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 200
}

export type inventoryUnloadConfigsRunUnloadAreaConfigResponse400 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 400
}

export type inventoryUnloadConfigsRunUnloadAreaConfigResponse404 = {
  data: ApiEnvelopeInventoryBotIdDto
  status: 404
}

export type inventoryUnloadConfigsRunUnloadAreaConfigResponseSuccess = (inventoryUnloadConfigsRunUnloadAreaConfigResponse200) & {
  headers: Headers;
};
export type inventoryUnloadConfigsRunUnloadAreaConfigResponseError = (inventoryUnloadConfigsRunUnloadAreaConfigResponse400 | inventoryUnloadConfigsRunUnloadAreaConfigResponse404) & {
  headers: Headers;
};

export type inventoryUnloadConfigsRunUnloadAreaConfigResponse = (inventoryUnloadConfigsRunUnloadAreaConfigResponseSuccess | inventoryUnloadConfigsRunUnloadAreaConfigResponseError)

export const getInventoryUnloadConfigsRunUnloadAreaConfigUrl = (id: string,) => {




  return `/api/inventory/unload-area-configs/${id}/run`
}

export const useInventoryUnloadConfigsRunUnloadAreaConfigHook = (): (id: string,
    inventoryRunUnloadAreaRequest?: InventoryRunUnloadAreaRequest, options?: RequestInit) => Promise<inventoryUnloadConfigsRunUnloadAreaConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    inventoryRunUnloadAreaRequest?: InventoryRunUnloadAreaRequest, options?: RequestInit) => {

        return customFetcher(getInventoryUnloadConfigsRunUnloadAreaConfigUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inventoryRunUnloadAreaRequest)
  }
);
      }
  }


export type inventoryUnloadConfigsStopUnloadAreaConfigResponse200 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 200
}

export type inventoryUnloadConfigsStopUnloadAreaConfigResponse404 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 404
}

export type inventoryUnloadConfigsStopUnloadAreaConfigResponseSuccess = (inventoryUnloadConfigsStopUnloadAreaConfigResponse200) & {
  headers: Headers;
};
export type inventoryUnloadConfigsStopUnloadAreaConfigResponseError = (inventoryUnloadConfigsStopUnloadAreaConfigResponse404) & {
  headers: Headers;
};

export type inventoryUnloadConfigsStopUnloadAreaConfigResponse = (inventoryUnloadConfigsStopUnloadAreaConfigResponseSuccess | inventoryUnloadConfigsStopUnloadAreaConfigResponseError)

export const getInventoryUnloadConfigsStopUnloadAreaConfigUrl = (id: string,
    params?: InventoryUnloadConfigsStopUnloadAreaConfigParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/inventory/unload-area-configs/${id}/stop?${stringifiedParams}` : `/api/inventory/unload-area-configs/${id}/stop`
}

export const useInventoryUnloadConfigsStopUnloadAreaConfigHook = (): (id: string,
    params?: InventoryUnloadConfigsStopUnloadAreaConfigParams, options?: RequestInit) => Promise<inventoryUnloadConfigsStopUnloadAreaConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    params?: InventoryUnloadConfigsStopUnloadAreaConfigParams, options?: RequestInit) => {

        return customFetcher(getInventoryUnloadConfigsStopUnloadAreaConfigUrl(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


